<main class="bg-main-gradient">
  <app-header GetTitle="How To Play" />

  <section class="mt-[59px] grid gap-6 lg:grid-cols-3">
    <app-rules GetIndex="01" GetTitle="choose a category"
      GetRules="First, choose a word category, like animals or movies. The computer then randomly selects a secret word from that topic and shows you blanks for each letter of the word." />
    <app-rules GetIndex="02" GetTitle="Guess letters"
      GetRules="First, choose a word category, like animals or movies. The computer then randomly selects a secret word from that topic and shows you blanks for each letter of the word." />
    <app-rules GetIndex="03" GetTitle="win or loose" GetRules="You win by guessing all the letters in the word before your health runs out. If the health bar empties before
    you guess the word, you lose." />

  </section>
</main>